import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { useNavigate } from 'react-router-dom';
import BlogServices from '../../services/BlogServices';

function UpdateBlog({ blog, onSuccess, closeModal }) {
  const [formValues, setFormValues] = useState({
    title: '',
    author: '',
    content: '',
    image: null,
  });

  // State for image preview
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_URL || 'http://localhost:3002';

  // Update form fields with existing blog data when 'blog' prop changes
  useEffect(() => {
    if (blog) {
      setFormValues({
        title: blog?.title || '',
        author: blog?.author || '',
        content: blog?.content || '',
        image: null, // No new image selected by default
      });

      // Set preview image if one exists
      if (blog?.image) {
        const imageUrl = blog?.image.startsWith('http')
          ? blog.image
          : `${API_URL.replace(/\/+$/, '')}/${blog?.image}`;
          console.log("Setting preview image URL:", imageUrl);
        setPreviewImage(imageUrl);
      }
    }
  }, [blog, API_URL]);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleContentChange = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      content: value,
    }));
  };
  // Handle file input changes (image file)
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.type)
    ) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues((prevValues) => ({
        ...prevValues,
        image: file,
      }));
    } else {
      alert('Invalid file type! Please upload a PNG, JPEG, JPG, or WEBP image.');
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();
      formData.append('title', formValues.title);
      formData.append('author', formValues.author);
      formData.append('content', formValues.content);

      if (formValues.image) {
        formData.append('image', formValues.image);
      }

      // Update the blog using the blog service
      await BlogServices.updateBlog(blog._id, formData);
      alert('Blog updated successfully');
      onSuccess(); // Callback on success
      closeModal(); // Close the modal
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Unknown error';
      alert(`Failed to update Blog: ${errorMessage}`);
    }
  };

  return (
    <div
      className="modal fade edit-box show d-block"
      id="editModal"
      tabIndex={-1}
      aria-labelledby="editBlogLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Blog</h5>
            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Title</label>
                          <input
                            type="text"
                            name="title"
                            className="form-control"
                            value={formValues.title}
                            onChange={handleInputChange}
                            placeholder="Enter blog title"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Author</label>
                          <input
                            type="text" 
                            name="author"
                            className="form-control"
                            value={formValues.author}
                            onChange={handleInputChange}
                            placeholder="Enter author name"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Image Upload */}
                    <div className="row mt-3">
                      <div className="col-sm-12">
                        <div className="input-field">
                          <label>
                            Upload Image<span className="red">*</span>
                          </label>
                          <input
                            type="file"
                            name="image"
                            className="form-control"
                            onChange={handleFileChange}
                          />
                          <p>
                            <span>
                              Drop an image or paste URL (up to resolution 1,500 x 1,500
                              px),
                            </span>{' '}
                            Supported formats: png, jpeg, jpg, webp
                          </p>
                          <div className="file-preview text-center">
                            <img
                              src={previewImage}
                              alt="Preview"
                              style={{
                                maxWidth: '100%',
                                maxHeight: '200px',
                                objectFit: 'contain',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Content Field */}
                    <div className="row mt-3">
                      <div className="col-lg-12">
                        <div className="input-field">
                          <label>Content</label>
                        <ReactQuill value={formValues.content} onChange={handleContentChange} theme="snow" />
                        </div>
                      </div>
                    </div>

                    <button type="submit" className="site-btn-green mt-3">
                      Update Blog
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateBlog;
